import Vue from 'vue'
import VueRouter from 'vue-router'
import permissionConstant from '@/constants/permission.js'
import store from '../store'

Vue.use(VueRouter)

const routes = [{
    path: '/login',
    name: 'Login',
    component: () => import('../views/Authentication/Login.vue')
},
{
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/Authentication/ForgotPassword.vue')
},
{
    path: '/forgot-password-expired',
    name: 'ResetPasswordExpired',
    component: () => import('../views/Authentication/ResetPasswordExpired.vue')
},
{
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () => import('../views/Authentication/ResetPassword.vue')
},
{
    path: '/time-attendance-pdf',
    name: 'ReportTimeAttendancePDF',
    component: () => import('../views/InquiryAndAttendance/ReportTimeAttendancePDF.vue'),
    meta: {
        requiresAuth: true,
        permission: [permissionConstant.ATTENDANCE.VIEW]
    }
},
{
    path: '/punch-log-attendance-pdf',
    name: 'ReportPunchLogPDF',
    component: () => import('../views/InquiryAndAttendance/ReportPunchLogPDF.vue'),
    meta: {
        requiresAuth: true,
        permission: [permissionConstant.ATTENDANCE.VIEW]
    }
},
{
    path: '/nvr-punch-log-pdf',
    name: 'ReportNVRPunchLogPDF',
    component: () => import('../views/ReportNVRPunchLogPDF.vue'),
    meta: {
        requiresAuth: true,
        permission: [permissionConstant.ATTENDANCE.VIEW]
    }
},
{
    path: '/blacklist-activity-pdf',
    name: 'ReportBlacklistActivityPDF',
    component: () => import('../views/Blacklist/ReportBlacklistActivityPDF.vue'),
    meta: {
        requiresAuth: true,
        permission: [permissionConstant.ATTENDANCE.VIEW]
    }
},
{
    path: '/visitor-activity-pdf',
    name: 'ReportVisitorActivityPDF',
    component: () => import('../views/Visitor/ReportVisitorActivityPDF.vue'),
    meta: {
        requiresAuth: true,
        permission: [permissionConstant.ATTENDANCE.VIEW]
    }
},
{
    path: '/',
    redirect: '/dashboard',
    meta: {
        requiresAuth: true,
        permission: [permissionConstant.DASHBOARD.VIEW]
    }
},
{
    path: '/primary',
    name: 'Primary',
    component: () => import('../views/Primary.vue'),
    children: [{
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.DASHBOARD.VIEW]
        }
    },
    {
        path: '/blacklist',
        name: 'Blacklist',
        component: () => import('../views/Blacklist/Blacklist.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.BLACKLIST.VIEW]
        },
        children: [{
            path: 'list',
            name: 'BlacklistLists',
            meta: {
                requiresAuth: false,
                permission: [permissionConstant.BLACKLIST.VIEW]
            }
        },
        {
            path: 'activity',
            name: 'BlacklistActivity',
            meta: {
                requiresAuth: false,
                permission: [permissionConstant.BLACKLIST.VIEW]
            }
        }]
    },
    {
        path: '/blacklist/info/:id',
        name: 'BlacklistInfo',
        component: () => import('../views/Blacklist/BlacklistInfo.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.BLACKLIST.VIEW]
        }
    },
    {
        path: '/blacklist/form/:id?',
        name: 'BlacklistForm',
        component: () => import('../views/Blacklist/BlacklistForm.vue'),
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.BLACKLIST.VIEW,
                permissionConstant.BLACKLIST.UPDATE
            ]
        }
    },
    {
        path: '/employees',
        name: 'Employees',
        component: () => import('../views/Employee/Employees.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.EMPLOYEE_MANAGEMENT.VIEW]
        }
    },
    {
        path: '/import-face',
        name: 'EmployeeImport',
        component: () => import('../views/Employee/EmployeeImport.vue'),
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.EMPLOYEE_MANAGEMENT.VIEW,
                permissionConstant.EMPLOYEE_MANAGEMENT.UPDATE
            ]
        }
    },
    {
        path: '/employee/:id?',
        name: 'EmployeeInfo',
        component: () => import('../views/Employee/EmployeeInfo.vue'),
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.EMPLOYEE_MANAGEMENT.VIEW,
                permissionConstant.EMPLOYEE_MANAGEMENT.UPDATE
            ]
        }
    },
    {
        path: '/user-form/:id?',
        name: 'UserForm',
        component: () => import('../views/UserForm.vue'),
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.COMPANY_SETTING.VIEW,
                permissionConstant.COMPANY_SETTING.UPDATE
            ]
        }
    },
    {
        path: '/account-setting',
        name: 'AccountInfo',
        component: () => import('../views/AccountSetting/AccountInfo.vue')
    },
    {
        path: '/account-edit',
        name: 'AccountForm',
        component: () => import('../views/AccountSetting/AccountForm.vue')
    },
    {
        path: '/company/setting',
        name: 'CompanySetting',
        component: () => import('../views/CompanySetting.vue'),
        meta: {
            requiresAuth: false,
            permission: [
                permissionConstant.COMPANY_SETTING.VIEW
            ]
        },
        children: [{
            path: 'company-profile',
            name: 'CompanyProfile',
            meta: {
                requiresAuth: false,
                permission: [permissionConstant.COMPANY_SETTING.VIEW]
            }
        },
        {
            path: 'user-management',
            name: 'UserManagement',
            meta: {
                requiresAuth: false,
                permission: [permissionConstant.COMPANY_SETTING.VIEW]
            }
        },
        {
            path: 'positions',
            name: 'Positions',
            meta: {
                requiresAuth: false,
                permission: [permissionConstant.COMPANY_SETTING.VIEW]
            }
        },
        {
            path: 'bureau',
            name: 'Bureau',
            meta: {
                requiresAuth: false,
                permission: [permissionConstant.COMPANY_SETTING.VIEW]
            }
        },
        {
            path: 'line-service',
            name: 'LineService',
            meta: {
                requiresAuth: false,
                permission: [permissionConstant.COMPANY_SETTING.VIEW]
            }
        }
        ]
    },
    {
        path: '/time-table-setting',
        name: 'TimeTableSetting',
        component: () => import('../views/TimeTableSetting.vue'),
        meta: {
            requiresAuth: false,
            permission: [permissionConstant.TIMETABLE_SETTING.VIEW]
        },
        children: [
            {
                path: 'workday',
                name: 'Workday',
                meta: {
                    requiresAuth: false,
                    permission: [permissionConstant.COMPANY_SETTING.VIEW]
                }
            },
            {
                path: 'special-workday',
                name: 'SpecialWorkday',
                meta: {
                    requiresAuth: false,
                    permission: [permissionConstant.COMPANY_SETTING.VIEW]
                }
            },
            {
                path: 'holiday',
                name: 'Holiday',
                meta: {
                    requiresAuth: false,
                    permission: [permissionConstant.COMPANY_SETTING.VIEW]
                }
            }
        ]
    },
    {
        path: '/devices',
        name: 'Devices',
        component: () => import('../views/Devices.vue'),
        meta: {
            requiresAuth: true,
            permission: []
        }
    },
    {
        path: '/device-management',
        name: 'DevicesManagementList',
        component: () => import('../views/DevicesManagement/DevicesManagementList.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.DEVICE_MANAGEMENT.VIEW]
        }
    },
    {
        path: '/visitor',
        name: 'Visitor',
        component: () => import('../views/Visitor/Visitor.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.VISITOR.VIEW]
        },
        children: [
            {
                path: 'list',
                name: 'VisitorLists',
                meta: {
                    requiresAuth: false,
                    permission: [permissionConstant.VISITOR.VIEW]
                }
            },
            {
                path: 'activity',
                name: 'VisitorActivity',
                meta: {
                    requiresAuth: false,
                    permission: [permissionConstant.VISITOR.VIEW]
                }
            }
        ]
    },
    {
        path: '/visitor/:id/view',
        name: 'VisitorInfo',
        component: () => import('../views/Visitor/VisitorInfo.vue'),
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.VISITOR.VIEW
            ]
        }
    },
    {
        path: '/visitor/form/:id?',
        name: 'VisitorForm',
        component: () => import('../views/Visitor/VisitorForm.vue'),
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.VISITOR.VIEW,
                permissionConstant.VISITOR.UPDATE
            ]
        }
    },
    {
        path: '/time-table-setting/workday/edit/:id',
        name: 'EditWorkday',
        component: () => import('../components/TimeTableSetting/WorkdayForm.vue'),
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.TIMETABLE_SETTING.VIEW,
                permissionConstant.TIMETABLE_SETTING.UPDATE
            ]
        }
    },
    {
        path: '/punch-log',
        name: 'NVRPunchLog',
        component: () => import('../views/PunchLog.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.NVR_PUNCH_LOG.VIEW]
        }
    },
    {
        path: '/activity-log',
        name: 'SystemActivityLog',
        component: () => import('../views/ActivityLog.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.ACTIVITY_LOG.VIEW]
        }
    },
    {
        path: '/inquiry-and-attendance',
        name: 'InquiryAndAttendance',
        component: () => import('../views/InquiryAndAttendance/InquiryAndAttendance.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.ATTENDANCE.VIEW]
        },
        children: [
            {
                path: 'inquiry',
                name: 'Inquiry',
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.ATTENDANCE.VIEW]
                }
            },
            {
                path: 'status-attendance',
                name: 'StatusAttendance',
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.ATTENDANCE.VIEW]
                }
            },
            {
                path: 'manage-attendance',
                name: 'ManageAttendance',
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.ATTENDANCE.VIEW]
                }
            },
            {
                path: 'punch-log',
                name: 'PunchLog',
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.ATTENDANCE.VIEW]
                }
            }
        ]
    },
    {
        path: '/inquiry-and-attendance/inquiry/:id',
        name: 'InquiryForm',
        component: () => import('../views/InquiryAndAttendance/InquiryForm.vue'),
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.ATTENDANCE.VIEW,
                permissionConstant.ATTENDANCE.UPDATE
            ]
        }
    },
    {
        path: '/inquiry-and-attendance/status-attendance/:id',
        name: 'StatusAttendanceForm',
        component: () => import('../views/InquiryAndAttendance/StatusAttendanceForm.vue'),
        meta: {
            requiresAuth: true,
            permission: [permissionConstant.ATTENDANCE.VIEW]
        }
    },
    {
        path: '/inquiry-and-attendance/manage-attendance/:id',
        name: 'ManageAttendanceForm',
        component: () => import('../views/InquiryAndAttendance/ManageAttendanceForm.vue'),
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.ATTENDANCE.VIEW,
                permissionConstant.ATTENDANCE.UPDATE
            ]
        }
    }
    ]
},

// for line liff
{
    path: '/liff',
    name: 'liff',
    component: () => import('../views/Liff/MainLayout.vue'),
    children: [{
        path: 'inquiry/create',
        name: 'inquiry-create',
        component: () => import('../views/Liff/Modules/Inquiry/pages/LeaveRequest.vue')
    },
    {
        path: 'inquiry/overview',
        name: 'inquiry-overview',
        component: () => import('../views/Liff/Modules/Inquiry/pages/InquiryOverview.vue')
    },
    {
        path: 'inquiry/bureau',
        name: 'inquiry-bureau',
        component: () => import('../views/Liff/Modules/Inquiry/pages/InquiryBureau.vue')
    },
    {
        path: 'history/attendance',
        name: 'history-attendance',
        component: () => import('../views/Liff/Modules/History/pages/HistoryAttendance.vue')
    },
    {
        path: 'history/quota',
        name: 'history-quota',
        component: () => import('../views/Liff/Modules/History/pages/HistoryQuota.vue')
    },
    {
        path: 'history/attendance/bureau',
        name: 'history-attendance-bureau',
        component: () => import('../views/Liff/Modules/History/pages/HistoryAttendanceBureau.vue')
    },
    {
        path: 'history/onsite',
        name: 'history-onsite',
        component: () => import('../views/Liff/Modules/History/pages/HistoryOnSite.vue')
    },
    {
        path: 'history/attendance/overview',
        name: 'history-attendance-overview',
        component: () => import('../views/Liff/Modules/History/pages/AttendanceOverview.vue')
    },
    {
        path: 'visitor/create',
        name: 'visitor-visitor',
        component: () => import('../views/Liff/Modules/Visitor/pages/VisitorCreate.vue')
    },
    {
        path: 'punch-log/security',
        name: 'punch-log-security',
        component: () => import('../views/Liff/Modules/Security/pages/PunchLogSecurity.vue')
    },
    {
        path: 'punch-log/security/:id',
        name: 'punch-log-security-detail',
        component: () => import('../views/Liff/Modules/Security/pages/PunchLogSecurityDetail.vue')
    },
    {
        path: '*',
        component: () => import('../views/NotFound.vue')
    }
    ]
},
{
    path: '/line-register',
    name: 'LineRegister',
    component: () => import('../views/Liff/LineRegister.vue')
},
{
    path: '/checkin-onsite',
    name: 'CheckinOnSite',
    component: () => import('../views/Liff/CheckinOnSite.vue'),
    meta: {
        requiresAuth: false
    }
},

{
    path: '/no-permission',
    name: 'NoPermission',
    component: () => import('../views/NoPermission.vue'),
    meta: {
        requiresAuth: false
    }
},
{
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const jwt = localStorage.getItem('jwt')
        if (!jwt || jwt === 'null') {
            next({ path: '/login' })
        } else if (to.meta.permission.length > 0) {
            const selfPermissionList = await store.dispatch('getSelfPermissionList')
            if (to.meta.permission.some(p => !selfPermissionList.includes(p))) {
                next({ path: '/no-permission' })
            }
        }
    }
    next()
})

export default router
